import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title
`

export const fragment = (name = 'testComponent') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
